import React, { Component } from "react";
import { Form as AForm } from "antd";

import "./index.less";

class Form extends Component {

  __data = null;
  __dataFields = [];
  formRef = React.createRef();

  getFieldError = (function (_this) {
    return function () {
      return _this.formRef.current.getFieldError.apply(_this.formRef.current, ...arguments);
    };
  })(this);

  getFieldInstance = (function (_this) {
    return function () {
      return _this.formRef.current.getFieldInstance.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  getFieldsError = (function (_this) {
    return function () {
      return _this.formRef.current.getFieldsError.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  getFieldsValue = (function (_this) {
    return function () {
      return _this.formRef.current.getFieldsValue.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  getFieldValue = (function (_this) {
    return function () {
      return _this.formRef.current.getFieldValue.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  isFieldsTouched = (function (_this) {
    return function () {
      return _this.formRef.current.isFieldsTouched.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  isFieldTouched = (function (_this) {
    return function () {
      return _this.formRef.current.isFieldTouched.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  isFieldValidating = (function (_this) {
    return function () {
      return _this.formRef.current.isFieldValidating.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  resetFields = (function (_this) {
    return function () {
      return _this.formRef.current.resetFields.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  scrollToField = (function (_this) {
    return function () {
      return _this.formRef.current.scrollToField.apply(_this.formRef.current, ...arguments);
    }
  })(this);

  setFields = (function (_this) {
    return function () {
      return _this.formRef.current.setFields.call(_this.formRef.current, ...arguments);
    }
  })(this);

  setFieldValue = (function (_this) {
    return function () {
      return _this.formRef.current.setFieldValue.call(_this.formRef.current, ...arguments);
    }
  })(this);

  setFieldsValue = (function (_this) {
    return function () {
      return _this.formRef.current.setFieldsValue.call(_this.formRef.current, ...arguments);
    }
  })(this);

  submit = (function (_this) {
    return function () {
      return _this.formRef.current.submit.call(_this.formRef.current, ...arguments);
    }
  })(this);

  validateFields = (function (_this) {
    return function () {
      return _this.formRef.current.validateFields.call(_this.formRef.current, ...arguments);
    }
  })(this);

  _getFields = () => {
    const { fields, data, } = this.props;
    if (Array.isArray(fields)) {
      return fields;
    }
    if (data && data !== this.__data) {
      this.__data = data;
      this.__dataFields = Object.keys(data).map(key => {
        return {
          name: [key],
          value: data[key],
        };
      });
    }
    return this.__dataFields;
  };

  render() {
    return (
      <AForm
        {...this.props}
        ref={this.formRef}
        fields={this._getFields()}
      >
        {this.props.children}
      </AForm>
    );
  };
}

Form.Item = AForm.Item;

Form.List = AForm.List;

Form.ErrorList = AForm.ErrorList;

Form.Provider = AForm.Provider;

export default Form;
